import { siteConfig } from '../config/siteConfig';

const CACHE = new Map();
export const CORONEL_DEFAULT = siteConfig?.map?.defaultCenter;
const USER_AGENT = 'CoronelPortal/1.0 (coronellocal.cl)';

export async function geocode(addressText, config = {}) {
  if (!addressText?.trim()) return null;

  const geocodingSuffix = config?.geocodingSuffix ?? siteConfig?.map?.geocodingSuffix;

  // La clave debe incluir el suffix efectivo: la misma dirección con un
  // suffix de ciudad distinto es una consulta distinta, no debe compartir
  // (ni contaminar) el resultado cacheado de otra ciudad.
  const normalizedAddress = addressText?.trim()?.toLowerCase();
  const normalizedSuffix = geocodingSuffix?.trim?.()?.toLowerCase();
  const key = `${normalizedAddress}|${normalizedSuffix}`;
  if (CACHE?.has(key)) return CACHE?.get(key);

  const query = encodeURIComponent(addressText?.trim() + ', ' + geocodingSuffix);
  const url = `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`;

  try {
    const res = await fetch(url, {
      headers: {
        'User-Agent': USER_AGENT,
        'Accept-Language': 'es',
      },
    });
    if (!res?.ok) throw new Error(`Nominatim error: ${res.status}`);
    const data = await res?.json();
    if (!data?.length) return null;
    const result = {
      lat: parseFloat(data?.[0]?.lat),
      lng: parseFloat(data?.[0]?.lon),
      display_name: data?.[0]?.display_name,
    };
    CACHE?.set(key, result);
    return result;
  } catch (err) {
    console.error('geocode error:', err);
    return null;
  }
}

export async function reverseGeocode(lat, lng) {
  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`;
  try {
    const res = await fetch(url, {
      headers: {
        'User-Agent': USER_AGENT,
        'Accept-Language': 'es',
      },
    });
    if (!res?.ok) return null;
    const data = await res?.json();
    return data?.display_name ?? null;
  } catch {
    return null;
  }
}
